"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailableOffersResponseToJSON = exports.AvailableOffersResponseFromJSONTyped = exports.AvailableOffersResponseFromJSON = exports.instanceOfAvailableOffersResponse = void 0;
var runtime_1 = require("../runtime");
var AvailableOffers_1 = require("./AvailableOffers");
/**
 * Check if a given object implements the AvailableOffersResponse interface.
 */
function instanceOfAvailableOffersResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAvailableOffersResponse = instanceOfAvailableOffersResponse;
function AvailableOffersResponseFromJSON(json) {
    return AvailableOffersResponseFromJSONTyped(json, false);
}
exports.AvailableOffersResponseFromJSON = AvailableOffersResponseFromJSON;
function AvailableOffersResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'offers': !(0, runtime_1.exists)(json, 'offers') ? undefined : (json['offers'].map(AvailableOffers_1.AvailableOffersFromJSON)),
    };
}
exports.AvailableOffersResponseFromJSONTyped = AvailableOffersResponseFromJSONTyped;
function AvailableOffersResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'offers': value.offers === undefined ? undefined : (value.offers.map(AvailableOffers_1.AvailableOffersToJSON)),
    };
}
exports.AvailableOffersResponseToJSON = AvailableOffersResponseToJSON;
